import React, { createContext, useContext, useState, useEffect } from 'react';
import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged 
} from 'firebase/auth';
import { auth } from '../config/firebase';
import api from '../utils/api';

const AuthContext = createContext({});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        // Kullanıcının admin olup olmadığını kontrol et
        try {
          // Token'ın eklenmesi için getIdToken çağrılır (interceptor kullanacaktır)
          const token = await user.getIdToken(true);
          const response = await api.post('/users/verify-admin');
          setIsAdmin(response.data.isAdmin === true);
        } catch (error) {
          console.error('Error checking admin status via API:', error);
          setIsAdmin(false);
        }
      } else {
        setCurrentUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const login = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      // Kullanıcının admin olup olmadığını kontrol et
      try {
        const token = await userCredential.user.getIdToken(true);
        const response = await api.post('/users/verify-admin');
        const adminStatus = response.data.isAdmin === true;
        
        console.log('Admin status via API:', adminStatus);
        setIsAdmin(adminStatus);
        
        return { success: true, user: userCredential.user, isAdmin: adminStatus };
      } catch (error) {
        console.error('Error checking admin status via API during login:', error);
        setIsAdmin(false);
        return { success: true, user: userCredential.user, isAdmin: false };
      }
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const value = {
    currentUser,
    isAdmin,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

